import * as React from "react";
import ConnectedFormControl from "../../FormControl/FormControl/FormControl.js";
import { isText } from "../../Util/Util/validations.js";
const MiddleName = ({
  label,
  errorMessage,
  validations = [isText],
  ...rest
}) => /* @__PURE__ */ React.createElement(
  ConnectedFormControl,
  {
    ...ConnectedFormControl.defaultProps,
    id: "middleName",
    "data-t": "middle-name",
    label,
    errorMessage,
    ...rest
  }
);
export {
  MiddleName as default
};
//# sourceMappingURL=MiddleName.js.map
